import { CallState, AgentState, UnavailableCode } from '../../types';
import { useAcceptRejectCall } from './useAcceptRejectCall';
import { useAgentStateAction } from './useAgentStateAction';
import { useConferenceRefresh } from './useConferenceRefresh';

interface UseCxoneCallActionsOptions {
  callState: CallState;
  unavailableCodes: UnavailableCode[];
  handleSessionError: (error: Error) => void;
  setCallState: React.Dispatch<React.SetStateAction<CallState>>;
  setAgentStateInternal: React.Dispatch<React.SetStateAction<AgentState>>;
  setIsRinging: React.Dispatch<React.SetStateAction<boolean>>;
  setCallError: React.Dispatch<React.SetStateAction<string | null>>;
  setAgentLegId: React.Dispatch<React.SetStateAction<string | null>>;
  setAgentLegStatus: React.Dispatch<React.SetStateAction<string | null>>;
  setIsAgentLegActive: React.Dispatch<React.SetStateAction<boolean>>;
  setIsInAcw: React.Dispatch<React.SetStateAction<boolean>>;
}

export function useCxoneCallActions({
  callState,
  unavailableCodes,
  handleSessionError,
  setCallState,
  setAgentStateInternal,
  setIsRinging,
  setCallError,
  setAgentLegId,
  setAgentLegStatus,
  setIsAgentLegActive,
  setIsInAcw,
}: UseCxoneCallActionsOptions) {
  const setAgentState = useAgentStateAction({
    unavailableCodes,
    handleSessionError,
    setCallState,
    setAgentStateInternal,
    setIsInAcw,
    setIsRinging,
    setIsAgentLegActive,
  });

  const { acceptCall, rejectCall } = useAcceptRejectCall({
    contactId: callState.contactId,
    handleSessionError,
    setCallState,
    setIsRinging,
    setCallError,
    setAgentLegId,
    setAgentLegStatus,
    setIsAgentLegActive,
  });

  const refreshConferenceParties = useConferenceRefresh(callState.isConference, setCallState);

  return {
    setAgentState,
    acceptCall,
    rejectCall,
    refreshConferenceParties,
  };
}
